import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import styles from './HpContactsTicketDeleteDialog.module.scss'

interface IHpContactsTicketDeleteDialogProps {
  isShow: boolean
  onClose: () => void
  handleDelete: () => void
}

export const HpContactsTicketDeleteDialog = ({
  isShow,
  handleDelete,
  onClose,
}: IHpContactsTicketDeleteDialogProps) => {
  return (
    <ModalDialog
      show={isShow}
      onClose={onClose}
      size={'xs'}
      content={() => (
        <div>
          <p className={styles.warning__title}>Warning!</p>
          <p className={styles.warning__text}>
            <Translation text="jbp-salesteam-ticket-delete" />
          </p>
          <div className={styles.warning__buttons}>
            <Button
              variant="contained"
              className={styles.warning__close}
              onClick={onClose}
              color="grey"
            >
              Cancel
            </Button>
            <Button onClick={handleDelete}>Delete</Button>
          </div>
        </div>
      )}
    />
  )
}
